module.exports = __webpack_public_path__ + "img/couples-075.ea6418f1.jpg";